<template>
  <ODialog ref="dialog" hideWhenLoading :maxWidth="600">
    <v-card v-if="clonedValues != null">
      <ODialogBar title="Selecionar Relays..." @close="dismiss" />
      <v-card-text class="pa-0">
        <OAutocompleteMultiple
          label="Buscar orgs..."
          :filter.sync="txtFilter"
          :filteredItems="filteredItems"
          v-model="clonedValues"
          innerListClass="h-300 overflow-y-scroll"
        />
      </v-card-text>
      <ODialogButtons
        class="pa-6"
        @apply="apply"
        @cancel="dismiss"
        txtApply="Salvar"
      />
    </v-card>
  </ODialog>
</template>

<script>
import OAutocompleteMultiple from 'oderon-vue/cpts/forms/OAutocompleteMultiple.vue'
import utils from 'oderon-commons/src/utils.js'
import { Org } from '../../../models'

function getEnv(org) {
  let tags = org.extraInfo && org.extraInfo.tags
  if (utils.hasTag(tags, 'PRD')) {
    return { cssClass: 'red white--text', text: 'PRD' }
  } else if (utils.hasTag(tags, 'HLG')) {
    return { cssClass: 'amber', text: 'HLG' }
  } else {
    return null
  }
}

export default {
  components: { OAutocompleteMultiple },
  data() {
    return {
      orgId: null,
      clonedValues: null,
      txtFilter: null,
      allItems: []
    }
  },
  computed: {
    filteredItems() {
      return this.allItems.filter((x) => {
        return utils.matchAnyLike(this.txtFilter, x.title, x.subtitle)
      })
    }
  },
  methods: {
    open(orgId) {
      this.orgId = orgId
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    async fetchData() {
      let orgs = await Org.findAll({ mini: true })
      this.allItems = orgs.map((x) => {
        return {
          id: x.id,
          title: x.name,
          subtitle: x.tags,
          rightChip: getEnv(x)
        }
      })

      let org = await Org.findById(this.orgId)
      let existing = org.extraInfo && org.extraInfo.relayOrgIds
      if (existing == null) existing = []

      this.clonedValues = existing.map((id) => {
        let o = this.allItems.find((x) => x.id == id)
        let title = (o && o.title) || `??${id}??`
        return { id, title }
      })
    },
    apply() {
      this.$refs.dialog.$loading(async () => {
        let old = await Org.findById(this.orgId)
        if (old.extraInfo == null) old.extraInfo = {}
        old.extraInfo.relayOrgIds = this.clonedValues.map((x) => x.id)
        await Org.save(old)
        this.$snack('Salvo com sucesso')
        this.$refs.dialog.$apply(true)
      })
    }
  }
}
</script>

<style></style>
